/*
  «Оплата й рівень» in «Мій профіль»: the ambassador changes their own Appstle
  subscription without leaving our page — level, pause and resume, card, cancel.

  WHY APPSTLE'S STOREFRONT API. Appstle owns the contract; Shopify shows a contract
  only to the app that created it, so neither our Admin token nor galas-account can
  touch it. Appstle's customer portal (/apps/subscriptions) talks to its own
  storefront API through the shop's app proxy, as the signed-in customer, with no
  key — so it works on every Appstle plan. These are the portal's calls, as it makes
  them (customer-v3 bundle, 2026-10):

    GET    api/subscription-customers-detail/valid/<customer id>   the contracts
    POST   api/subscription-contract-details/replace-variants-v3   change level
    PUT    api/subscription-contracts-update-status?status=PAUSED|ACTIVE
    PUT    api/subscription-contracts-update-payment-method        Shopify mails a card link
    DELETE api/subscription-contracts/<id>                         cancel

  Shopify stamps the proxied request with the signed-in customer, so nobody can
  reach another person's contract from here. When anything fails (signed out of
  the shop, Appstle down, a contract we cannot read), the rows stay what they were:
  links to Appstle's portal.

  A level change sets the price of the NEXT monthly charge; orders-paid reads the
  tier from that payment's amount, so the profile's tier card follows on that date.

  Used by assets/profile.js: GalasAmbassadorManage.controls(api, onState).
*/
(function () {
  var BASE = '/apps/subscriptions/cp/api/';
  var CHEVRON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"></polyline></svg>';
  var CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  // One sheet for the page: the profile redraws its panel (and so calls controls()
  // again) after every save, and a second dialog's radios would share a group.
  var sheet = null;

  function numericId(value) { return String(value == null ? '' : value).split('/').pop(); }

  function request(method, path, body) {
    return fetch(BASE + path, {
      method: method,
      credentials: 'same-origin',
      headers: body ? { Accept: 'application/json', 'Content-Type': 'application/json' } : { Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (res) {
      return res.text().then(function (text) {
        var data = null;
        try { data = text ? JSON.parse(text) : null; } catch (e) { data = null; }
        if (!res.ok) { var error = new Error((data && (data.message || data.title)) || String(res.status)); error.status = res.status; throw error; }
        return data;
      });
    });
  }

  // The ambassador contract: the newest live one that carries one of our tier
  // variants; failing that, the newest cancelled one, so a former ambassador sees
  // «Скасовано» and the way back rather than nothing.
  function load(customerId, tiers) {
    var byVariant = {};
    tiers.forEach(function (t) { byVariant[t.variant] = t; });
    var rank = { active: 0, paused: 1, cancelled: 2 };
    return request('GET', 'subscription-customers-detail/valid/' + encodeURIComponent(customerId)).then(function (list) {
      var found = (Array.isArray(list) ? list : []).map(function (c) {
        var lines = [];
        try { lines = JSON.parse(c.contractDetailsJSON || '[]') || []; } catch (e) { lines = []; }
        var line = null;
        lines.some(function (l) { if (byVariant[numericId(l.variantId)]) { line = l; return true; } return false; });
        if (!line) return null;
        return {
          id: numericId(c.subscriptionContractId || c.graphSubscriptionContractId),
          status: String(c.status || '').toLowerCase(),
          next: c.nextBillingDate || null,
          lineId: line.lineId || line.id,
          quantity: Number(line.quantity) || 1,
          tier: byVariant[numericId(line.variantId)],
          created: c.createdAt || c.activatedOn || ''
        };
      }).filter(function (c) { return c && c.id && c.status in rank; });
      found.sort(function (a, b) {
        if (a.status !== b.status) return rank[a.status] - rank[b.status];
        return String(b.created).localeCompare(String(a.created));
      });
      return found[0] || null;
    });
  }

  function controls(api, onState) {
    var el = api.el, T = api.T, cfg = api.cfg, fill = api.fill;
    var tiers = (cfg.tiers || []).filter(function (t) { return t.variant; });
    var customerId = cfg.auth && cfg.auth.customer_id;
    var contract = null;

    // While the contract is read, the line already holds its place (no jump) and
    // the buttons wait; if it cannot be read, they turn into links to the portal.
    var status = el('p', { class: 'amb-manage__status' }, el('span', { class: 'amb-manage__next', text: T.manage_loading }));
    var main = el('span');
    var list = el('ul', { class: 'profile-manage', role: 'list' });
    var wrap = el('div', { class: 'amb-manage', 'aria-busy': 'true' }, [status, main, list]);

    function setMain(label, how) {
      var next = typeof how === 'string'
        ? el('a', { class: 'button button--primary profile-manage__main', href: how }, el('span', { class: 'button__label', text: label }))
        : el('button', { type: 'button', class: 'button button--primary profile-manage__main', disabled: !how, onclick: how || null },
          el('span', { class: 'button__label', text: label }));
      main.replaceWith(next);
      main = next;
    }
    function row(label, quiet, how) {
      var inner = [el('span', { text: label }), el('span', { class: 'profile-manage__chevron', 'aria-hidden': 'true', html: CHEVRON })];
      var cls = 'profile-manage__row' + (quiet ? ' profile-manage__row--quiet' : '');
      return el('li', null, typeof how === 'string'
        ? el('a', { class: cls, href: how }, inner)
        : el('button', { type: 'button', class: cls, disabled: !how, onclick: how || null }, inner));
    }
    function rows(items) {
      api.clear(list);
      list.hidden = !items.length;
      items.forEach(function (li) { list.appendChild(li); });
    }

    function drawWaiting() {
      setMain(T.manage_change, null);
      rows([row(T.manage_pause), row(T.manage_card), row(T.manage_cancel, true)]);
    }

    function drawPortal() {
      wrap.removeAttribute('aria-busy');
      status.hidden = true;
      setMain(T.manage_change, cfg.portalUrl);
      rows([row(T.manage_pause, false, cfg.portalUrl), row(T.manage_card, false, cfg.portalUrl), row(T.manage_cancel, true, cfg.portalUrl)]);
    }

    function drawLive() {
      var state = contract.status;
      wrap.removeAttribute('aria-busy');
      status.hidden = false;
      api.clear(status);
      var chip = { active: ['ok', T.manage_active], paused: ['warn', T.manage_paused], cancelled: ['off', T.manage_cancelled_chip] }[state];
      status.appendChild(el('span', { class: 'amb-cab__chip amb-cab__chip--' + chip[0], text: chip[1] }));
      status.appendChild(el('span', {
        class: 'amb-manage__next',
        text: state === 'active' ? fill(T.manage_next, { date: api.date(contract.next), amount: contract.tier.amount + ' ' + cfg.currency })
          : state === 'paused' ? T.manage_paused_note : T.manage_cancelled_note
      }));
      if (state === 'cancelled') {
        setMain(T.manage_return, cfg.tiersUrl || '/pages/ambassadors');
        rows([]);
      } else if (state === 'paused') {
        // Paused: coming back is the one thing most people here want.
        setMain(T.manage_resume, resume);
        rows([row(T.manage_change, false, function () { openTiers(); }), row(T.manage_card, false, card), row(T.manage_cancel, true, openCancel)]);
      } else {
        setMain(T.manage_change, function () { openTiers(); });
        rows([row(T.manage_pause, false, openPause), row(T.manage_card, false, card), row(T.manage_cancel, true, openCancel)]);
      }
      if (onState) onState(contract);
    }

    function refresh() {
      if (!customerId || !tiers.length) { drawPortal(); return Promise.resolve(); }
      return load(customerId, tiers).then(function (c) {
        contract = c;
        if (c) drawLive(); else drawPortal();
      }, function () { drawPortal(); });
    }

    // The tier cards on the ambassadors page send a member here with
    // ?manage=level&tier=<amount>: open the level sheet with that level picked.
    function openFromLink() {
      var params = new URLSearchParams(location.search);
      if (params.get('manage') !== 'level') return;
      params.delete('manage');
      var wanted = params.get('tier');
      params.delete('tier');
      var query = params.toString();
      history.replaceState(history.state, '', location.pathname + (query ? '?' + query : '') + location.hash);
      if (!contract || contract.status === 'cancelled') return;
      wrap.scrollIntoView({ block: 'center' });
      openTiers(wanted);
    }

    /* ── the sheet ─────────────────────────────────────────────────────── */
    function openSheet(title, body, actions) {
      if (!sheet) {
        sheet = el('dialog', { class: 'profile-qr amb-manage__sheet', 'aria-labelledby': 'amb-manage-title' });
        sheet.addEventListener('click', function (e) { if (e.target === sheet) sheet.close(); });
        document.body.appendChild(sheet);
      }
      api.clear(sheet);
      sheet.appendChild(el('div', { class: 'profile-qr__inner amb-manage__inner' }, [
        el('button', { type: 'button', class: 'profile-qr__close', 'aria-label': T.close, html: CLOSE, onclick: function () { sheet.close(); } }),
        el('p', { id: 'amb-manage-title', class: 'profile-qr__title', text: title }),
        body,
        el('p', { class: 'amb-manage__error', role: 'alert', hidden: true }),
        el('div', { class: 'amb-manage__actions' }, actions)
      ]));
      if (!sheet.open) sheet.showModal();
    }
    function action(label, kind, onClick) {
      return el('button', { type: 'button', class: 'button ' + (kind || 'button--primary'), onclick: onClick },
        el('span', { class: 'button__label', text: label }));
    }
    function busy(button, on) {
      button.disabled = on;
      button.classList.toggle('is-busy', on);
    }
    // Run a change, then read the contract again so the card shows what Appstle holds.
    function apply(button, promise, done) {
      busy(button, true);
      return promise.then(function () {
        return refresh().then(function () {
          if (sheet && sheet.open) sheet.close();
          api.flash(done);
        });
      }, function () {
        busy(button, false);
        // A toast would sit under the open sheet (the dialog is the top layer).
        var error = sheet && sheet.open && sheet.querySelector('.amb-manage__error');
        if (error) { error.textContent = T.manage_failed; error.hidden = false; }
        else api.flash(T.manage_failed, true);
      });
    }

    function openTiers(wantedAmount) {
      var wanted = tiers.filter(function (t) { return String(t.amount) === String(wantedAmount); })[0];
      var picked = (wanted || contract.tier).variant;
      var options = tiers.map(function (t, i) {
        var current = t.variant === contract.tier.variant;
        var input = el('input', { type: 'radio', name: 'amb-manage-tier', value: t.variant, class: 'amb-manage__radio' });
        input.checked = t.variant === picked;
        input.addEventListener('change', function () { picked = t.variant; sync(); });
        return el('label', { class: 'amb-manage__tier' + (current ? ' is-current' : '') }, [
          input,
          el('span', { class: 'amb-manage__tier-text' }, [
            el('span', { class: 'amb-manage__tier-name', text: T.tier_names[i + 1] }),
            el('span', { class: 'amb-manage__tier-price', text: t.amount + ' ' + cfg.currency + T.per_month })
          ]),
          current ? el('span', { class: 'amb-cab__chip amb-cab__chip--ok', text: T.manage_current }) : null
        ]);
      });
      var note = el('p', { class: 'amb-cab__muted amb-manage__note' });
      var confirm = action(T.manage_change_cta, 'button--primary', function () {
        var target = tiers.filter(function (t) { return t.variant === picked; })[0];
        if (!target || target.variant === contract.tier.variant) return;
        var newVariants = {};
        newVariants[target.variant] = contract.quantity;
        apply(confirm, request('POST', 'subscription-contract-details/replace-variants-v3', {
          contractId: Number(contract.id),
          oldVariants: [Number(contract.tier.variant)],
          newVariants: newVariants,
          oldLineId: contract.lineId
        }), fill(T.manage_changed, { tier: T.tier_names[tiers.indexOf(target) + 1] }));
      });
      function sync() {
        var target = tiers.filter(function (t) { return t.variant === picked; })[0];
        var same = !target || target.variant === contract.tier.variant;
        confirm.disabled = same;
        confirm.querySelector('.button__label').textContent = same ? T.manage_change_cta
          : fill(T.manage_change_to, { tier: T.tier_names[tiers.indexOf(target) + 1], amount: target.amount + ' ' + cfg.currency });
        note.textContent = same ? T.manage_change_hint
          : fill(contract.status === 'paused' ? T.manage_change_note_paused : T.manage_change_note, { date: api.date(contract.next) });
      }
      openSheet(T.manage_change, el('div', { class: 'amb-manage__body' }, [
        el('fieldset', { class: 'amb-manage__tiers' }, [el('legend', { class: 'visually-hidden', text: T.manage_change })].concat(options)),
        note
      ]), [confirm]);
      sync();
    }

    function openPause() {
      var go = action(T.manage_pause_cta, 'button--primary', function () {
        apply(go, request('PUT', 'subscription-contracts-update-status?contractId=' + contract.id + '&status=PAUSED&isExternal=true'), T.manage_paused_done);
      });
      openSheet(T.manage_pause_title, el('p', { class: 'amb-cab__muted', text: T.manage_pause_body }),
        [go, action(T.manage_keep, 'button--secondary', function () { sheet.close(); })]);
    }

    function resume(e) {
      apply(e.currentTarget, request('PUT', 'subscription-contracts-update-status?contractId=' + contract.id + '&status=ACTIVE&isExternal=true'), T.manage_resumed);
    }

    function card(e) {
      apply(e.currentTarget, request('PUT', 'subscription-contracts-update-payment-method?contractId=' + contract.id + '&isExternal=true'),
        fill(T.manage_card_sent, { email: cfg.email || '' }));
    }

    function openCancel() {
      var go = action(T.manage_cancel_cta, 'button--secondary amb-manage__danger', function () {
        apply(go, request('DELETE', 'subscription-contracts/' + contract.id + '?isExternal=true'), T.manage_cancelled);
      });
      var actions = [action(T.manage_keep, 'button--primary', function () { sheet.close(); })];
      // Pausing keeps the level and the bonuses' history; offer it first, never instead.
      if (contract.status !== 'paused') actions.push(action(T.manage_pause_instead, 'button--secondary', openPause));
      actions.push(go);
      openSheet(T.manage_cancel_title, el('p', { class: 'amb-cab__muted', text: T.manage_cancel_body }), actions);
    }

    drawWaiting();
    refresh().then(openFromLink);
    return wrap;
  }

  window.GalasAmbassadorManage = { controls: controls };
})();
